import { render, staticRenderFns } from "./PanelCompetitionClassificationsForm.vue?vue&type=template&id=8f6b34d4&scoped=true&"
import script from "./PanelCompetitionClassificationsForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionClassificationsForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionClassificationsForm.vue?vue&type=style&index=0&id=8f6b34d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6b34d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f6b34d4')) {
      api.createRecord('8f6b34d4', component.options)
    } else {
      api.reload('8f6b34d4', component.options)
    }
    module.hot.accept("./PanelCompetitionClassificationsForm.vue?vue&type=template&id=8f6b34d4&scoped=true&", function () {
      api.rerender('8f6b34d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionClassificationsForm.vue"
export default component.exports